/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {requestCompletionNotification} from '../api'

export const useMutationRequestCompletionNotification = createReactQueryMutationHook('requestCompletionNotification', requestCompletionNotification)
